import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { changeActivePage } from 'actions/ListActions';

import Loader from 'components/layout/Loader';
import Pagination from 'components/layout/Pagination';

import List from 'components/List';

import OrderInfosCustomer from 'components/layout/order/OrderInfosCustomer';

class ClientCarServices extends React.Component {
  render() {
    const { entity, entityLoaded, list } = this.props;

    let urlData = {};
    if (entityLoaded) {
      urlData = {
        filters: {
          type: ['car_service'],
          'items._id': entity.getItem().getId(),
        },
      };
    }

    return (
      <div class="clearfix p-t-15 p-b-15">
        {entityLoaded ? (
          <div>
            <List listName="orders" url="/api/orders.json" urlData={urlData} list={list} noRender />

            {list.pending ? (
              <Loader />
            ) : (
              <div>
                {!list.data.pending && list.data.count === 0 && <div>No bookings found</div>}

                {list.data.list.map(order => {
                  return <OrderInfosCustomer order={order} key={order.id} />;
                })}

                {!list.pending && !!list.data.count && (
                  <div class="text-center">
                    <Pagination
                      count={list.data.count}
                      resPerPage={list.resPerPage}
                      activePage={list.activePage}
                      handleSelect={this.handlePagination}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    list: state.list.orders,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    changeActivePage: (listName, activePage, resPerPage) => {
      dispatch(changeActivePage(listName, activePage, resPerPage));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ClientCarServices)
  )
);
